import React from 'react';
import ReactDOM from 'react-dom/client';
import { CssBaseline, ThemeProvider } from '@mui/material';

import theme from './theme.ts';
import App from './App.tsx';
import './stylesheets/main.scss';
import { Provider } from 'react-redux';
import { QueryClientProvider } from '@tanstack/react-query';
import { LoadingProvider } from './context/LoadingContext.tsx';
import store from './redux/store.ts';
import queryClient from './lib/queryClient.ts';
import * as Sentry from '@sentry/react';
import {
  SENTRY_DSN,
  SENTRY_ENVIRONMENT,
  SENTRY_RELEASE,
  API_BASE_URL,
} from './constants/apiEndpoints.ts';
// import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

Sentry.init({
  dsn: SENTRY_DSN,
  environment: SENTRY_ENVIRONMENT,
  release: SENTRY_RELEASE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.browserProfilingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: ['localhost', `/^${API_BASE_URL}/`],
  // Set profilesSampleRate to 1.0 to profile every transaction.
  // Since profilesSampleRate is relative to tracesSampleRate,
  // the final profiling rate can be computed as tracesSampleRate * profilesSampleRate
  // For example, a tracesSampleRate of 0.5 and profilesSampleRate of 0.5 would
  // results in 25% of transactions being profiled (0.5*0.5=0.25)
  profilesSampleRate: 1.0,
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <LoadingProvider>
          <QueryClientProvider client={queryClient}>
            <App />

            {/* <ReactQueryDevtools initialIsOpen={true} /> */}
          </QueryClientProvider>
        </LoadingProvider>
      </Provider>
    </ThemeProvider>
  </React.StrictMode>
);
